import 'react';
import '../Provider/ThemeContext.js';
import 'classnames';
import { css } from 'emotion';
import { keyframes, css as css$1 } from '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import '../utils/useTheme.js';
import '../utils/useLocalStorage.js';
import { a as _taggedTemplateLiteralLoose } from '../chunk-1b90139e.js';
import '../utils/omit.js';
import '../ColorMode/utils.js';
import '../ColorMode/ColorModeContext.js';
import '../ColorMode/InitializeColorMode.js';
import '../utils/pick.js';
import '../utils/cssProps.js';
import 'lodash/kebabCase';
import 'tinycolor2';
import '../utils/isFunction.js';
import '../utils/get.js';
import { theme } from '../utils/theme.js';
import '../utils/getCSSFromStyleObject.js';
import '../utils/useStyle.js';
import '../utils/usePrevious.js';
import '../utils/useOptionsState.js';
import '../utils/omitBy.js';
import '../utils/useDefaultProps.js';
import '../utils/useDebounce.js';
import 'lodash/uniq';
import '../utils/useClassName.js';
import '../utils/getMediaQueryList.js';
import '../utils/useBreakpointValue.js';
import '../utils/useBreakpoint.js';
import 'reakit/Id';
import '../utils/uniqueId.js';
import '../utils/times.js';
import '../utils/parseIcons.js';
import '../utils/colors.js';
import '../utils/palette.js';
import '../utils/mergeRefs.js';
import 'deepmerge';
import 'lodash/set';
import '../utils/applyTheme.js';
import '../utils/bindFns.js';
import '../utils/createComponent.js';
import '../utils/createElement.js';
import '../utils/createHook.js';
import '../utils/forwardRefWithUse.js';
import '../utils/fieldAdaptors.js';
import 'capsize';
import '../utils/getCapsizeStyles.js';
import '@emotion/is-prop-valid';
import '../utils/htmlProps.js';
import '../utils/OutsideClickHandler.js';

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n          transform: translateY(0);\n        "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n          transform: translateX(0);\n        "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n        ", " ", ";\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n        opacity: 1;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n            transform: translateY(", ");\n          "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n            transform: translateX(", ");\n          "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n            transform: translateY(", ");\n          "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n            transform: translateX(", ");\n          "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n        ", "\n        ", "\n        ", "\n        ", "\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n        opacity: 0;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  from {\n    ", "\n\n    ", "\n  }\n\n  to {\n    ", "\n\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    min-width: 350px;\n  }\n\n  & .bb-Toast {\n    animation: ", " 250ms ease-in-out forwards;\n  }\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Toast = function Toast(styleProps) {
  return css(_templateObject(), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var ToastOverlay = function ToastOverlay(styleProps) {
  return css(_templateObject2(), getAnimation(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var getAnimation = function getAnimation(styleProps) {
  return keyframes(_templateObject3(), styleProps.fade && css$1(_templateObject4()), styleProps.slide && css$1(_templateObject5(), ['top-end', 'right', 'bottom-end'].includes(styleProps.placement) && css$1(_templateObject6(), styleProps.fade ? '10%' : '130%'), ['bottom'].includes(styleProps.placement) && css$1(_templateObject7(), styleProps.fade ? '10%' : '130%'), ['top-start', 'left', 'bottom-start'].includes(styleProps.placement) && css$1(_templateObject8(), styleProps.fade ? '-10%' : '-130%'), ['top'].includes(styleProps.placement) && css$1(_templateObject9(), styleProps.fade ? '-10%' : '-130%')), styleProps.fade && css$1(_templateObject10()), styleProps.slide && css$1(_templateObject11(), ['top-end', 'right', 'bottom-end', 'top-start', 'left', 'bottom-start'].includes(styleProps.placement) && css$1(_templateObject12()), ['bottom', 'top'].includes(styleProps.placement) && css$1(_templateObject13())));
};

var styles = /*#__PURE__*/Object.freeze({
  Toast: Toast,
  ToastOverlay: ToastOverlay
});
export { Toast as T, ToastOverlay as a, styles as s };